import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { LIFESTYLE_IMAGE } from "@/lib/faro";

const CHAPTERS = [
  {
    n: "01",
    title: "Experiencia que se nota",
    body: "45 años en las carreteras de Vigo. Miles de conductores han empezado con nosotros. La veteranía no se improvisa: se conduce.",
  },
  {
    n: "02",
    title: "Una flota de 25 vehículos",
    body: "15+ coches, 6 motos, camión, autobús, semirremolque y cuadriciclo propio. Lo que quieras conducir, aquí lo practicas de verdad.",
  },
  {
    n: "03",
    title: "Cerca de ti, siempre",
    body: "5 centros repartidos por el área metropolitana. Elige el que mejor te venga y empieza tu formación cerca de casa.",
  },
  {
    n: "04",
    title: "Preparados para todo",
    body: "Pistas propias para el examen DGT, vehículo adaptado a diversidad funcional y formación profesional CAP. Sin excusas para no aprobar.",
  },
];

export default function Manifesto() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], [-40, 40]);

  return (
    <section ref={ref} className="section-pad bg-[var(--faro-bg)] relative overflow-hidden" data-testid="manifesto-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <span className="eyebrow">Por qué Faro</span>
          <h2 className="font-display font-black tracking-tighter text-4xl sm:text-6xl mt-3 max-w-4xl leading-[0.95]">
            No es solo sacarte el carnet.<br />Es conducir con cabeza toda la vida.
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mt-14 items-start">
          <div className="lg:col-span-7 divide-y divide-[rgba(30,42,143,0.12)]">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.05} className="py-7 first:pt-0 group">
                <div className="flex items-start gap-6">
                  <div className="font-display font-black text-3xl sm:text-4xl text-[var(--faro-red)] tabular-nums shrink-0 w-16">
                    {c.n}
                  </div>
                  <div>
                    <h3 className="font-display font-bold text-2xl sm:text-3xl text-[var(--faro-text)] group-hover:text-[var(--faro-blue)] transition-colors">
                      {c.title}
                    </h3>
                    <p className="mt-2 text-base sm:text-lg text-[var(--faro-text-soft)] leading-relaxed max-w-xl">
                      {c.body}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <div className="relative aspect-[3/4] rounded-[2rem] overflow-hidden border border-[rgba(30,42,143,0.15)] shadow-xl">
              <motion.img
                style={{ y: imgY }}
                src={LIFESTYLE_IMAGE}
                alt="Alumna de Autoescuelas Faro sonriendo al volante tras aprobar el examen de conducir en Vigo"
                width="900"
                height="1200"
                loading="lazy"
                decoding="async"
                className="w-full h-[120%] object-cover will-change-transform"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[rgba(30,42,143,0.5)] to-transparent" />
              <div className="absolute bottom-5 left-5 right-5 text-white">
                <div className="text-xs uppercase tracking-[0.2em] font-bold text-[var(--faro-yellow)]">Desde 1980</div>
                <div className="font-display font-black text-2xl mt-1">Tu confianza al volante empieza aquí.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
